import React, { useState } from "react";
import _ from "lodash";
import moment from "moment";
import "moment-timezone";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table/css/react-bootstrap-table.css";
import DatePicker from "react-datepicker";
import { Modal, Button } from "react-bootstrap";
import { AddPO } from "../../partial/addPO";
import DepositModal from "../../partial/DepositModal";
import CompletionPhotosModal from "../../partial/CompletionPhotosModal";
import Select from "../../common/select";
import "react-datepicker/dist/react-datepicker.css";
import StarRatingComponent from "react-star-rating-component";
import { convertFromUTC } from "../../../util/convert_timezone";
import ScopeService from "../../../services/scopeService";
import dateService from "../../../services/dateService";
import PaymentProgressModal from "../../partial/PaymentProgressModal";
import { HTTPService } from "./../../../services/httpService";
import { canTransferJob } from "../../../util/jobUtils";
import { getScheduleNotification } from "../../../util/dateDisplayUtils";
import { isMultiLocation, isMobileLocation } from "../../../util/locationUtils";
import MobileAppointmentForm from "../../partial/MobileAppointmentForm";
import TechPicker from "../../common/TechPicker";

const API = new HTTPService();

// Constants
const USER_ACCESS_ASSIST = "ASSIST";
const REQUEST_STATES = {
  NEW: "new",
  ANSWERED: "answered",
  SCHEDULED: "scheduled",
  STARTED: "started",
  RECEIVED: "received",
  FINISHED: "finished",
  COLLECTED: "collected"
};

const USER_TYPES = {
  DEALER: "dealer",
  INSTALLER: "installer"
};

const REQUEST_TYPES = {
  DEALER: "dealer",
  INSTALLER: "installer"
};

const SERVICE_STATES = {
  NEW: "new",
  STARTED: "started"
};

const WORK_STATUSES = ['booked', 'pending', 'started'];

// Utility Functions
const formatCurrency = (amount) => {
  return isNaN(amount) ? "$0.00" : "$" + amount.toFixed(2);
};

const ScheduleNotification = ({ request, calendarDays }) => {
//console.log("ScheduleNotification called with request:", request, calendarDays);
  const notification = getScheduleNotification(request, calendarDays);
//console.log("ScheduleNotification returns:", notification);
  
  if (!notification) return null;
  
  const alertClass = notification.type === 'warning' ? 'alert-warning' : 'alert-info';
  
  return (
    <div className={`alert ${alertClass} mx-3 mb-3`} style={{ fontSize: '14px' }}>
      {notification.icon} {notification.message}
    </div>
  );
};

// Helper function to fetch signed URL for contract viewing
const fetchSignedUrl = async (requestId) => {
  const newTab = window.open("", "_blank");
  try {
    const response = await API.get(`signedURL/?requestId=${requestId}`);
    if (response.data.signedUrl) {
      newTab.location.href = response.data.signedUrl;
    } else {
      console.error("No signed URL found.");
      alert("Error accessing contract.");
    }
  } catch (error) {
    console.error("Error fetching signed URL:", error);
    alert("Error accessing contract.");
  }
};

const formatServiceAmount = (service, discount = 0) => {
  // If service_discount is already stored separately, use it
  const serviceDiscount = service.service_discount || discount || 0;
  const amount = parseFloat(service.service_amount) - parseFloat(serviceDiscount);
  return formatCurrency(amount);
};

const formatDateString = (date) => {
  if (!date) return 'Not set';
  return dateService.displayDate(date, "ddd, MMM Do, YYYY");
};

const prepareServiceData = (services) => {
  return services.map(service => {
    // Don't modify service_amount - let the formatter handle discount display
    return {
      ...service,
      service_amount: parseFloat(service.service_amount), // Keep original amount
      service_discount: parseFloat(service.service_discount || 0)
    };
  });
};
const prepareOffersData = (offers) => {
  return offers.map(offer => ({
    ...offer,
    startDateString: formatDateString(offer.startDate),
    installerName: offer.installerName
  }));
};

const handleCheckIn = async (request, routerHistory) => {

  console.log ("here's the requst for checkin", request)
  try {

      routerHistory.push(`/requests/${request.requestId}/checkin`);
/*
    // Check if check-in wizard is enabled for this installer
    const installer = this.state.installer || this.props.installer;

    if (installer && installer.checkin_wizard_enabled) {
      // Use new check-in wizard
      this.props.history.push(`/requests/${requestId}/checkin`);
    } else {
      // Fallback to existing simple flow (if you have one)
      alert('Check-in wizard not enabled for this account');
    }
      */
  } catch (error) {
    console.error('Error starting check-in:', error);
    alert('Error starting check-in. Please try again.');
  }
};

// Add this enhanced column definition for dealers near the existing getServiceColumns function
const getDealerServiceColumns = () => [
  {
    dataField: "description",
    text: "Service",
    formatter: (cell, row) => {
      const cat = row.service_category ? `${row.service_category} - ` : '';
      return `${cat}${cell || '-'}`;
    }
  },
{ 
  dataField: "service_amount", 
  text: "Specialist Cost", 
  formatter: (cell, row) => formatServiceAmount(row)
},  { 
    dataField: "retail_price", 
    text: "Customer Price", 
    formatter: (cell, row) => {
      // Use retail_price if available, otherwise fall back to service_amount
      const retailPrice = cell || row.service_amount || 0;
      return formatCurrency(parseFloat(retailPrice));
    }
  },
{
  dataField: "margin",
  text: "Margin",
  formatter: (cell, row) => {
    const retailPrice = parseFloat(row.retail_price || row.service_amount || 0);
    const serviceDiscount = parseFloat(row.service_discount || 0);
    const specialistCost = parseFloat(row.service_amount || 0) - serviceDiscount; // ✅ Discounted
    const margin = retailPrice - specialistCost;
    return (
      <span className={margin >= 0 ? "text-success" : "text-danger"}>
        {formatCurrency(margin)}
      </span>
    );
  }
},
  { dataField: "service_duration", text: "Duration" }
];

const getCustomServiceColumns = (onSelectProduct, categoryHasProducts) => [
  {
    dataField: "custom_description",
    text: "Service",
    formatter: (cell, row) => {
      // Check if service has items (new model)
      const hasItems = row.items && row.items.length > 0;
      const materialItems = hasItems ? row.items.filter(i => !i.type || i.type === 'material') : [];
      const allItemsAssigned = materialItems.length > 0 && materialItems.every(i => i.recommended_product_id);

      // Legacy: check if recommended product is set (service-level)
      const hasRecommendedProduct = !hasItems && row.recommended_product_id && row.recommended_product_name;
      const recommendedProductDisplay = hasRecommendedProduct
        ? (row.recommended_product_brand
            ? `${row.recommended_product_brand} - ${row.recommended_product_name}`
            : row.recommended_product_name)
        : null;

      const cat = row.service_category ? `${row.service_category} - ` : '';

      return (
        <div>
          <div className="d-flex align-items-start justify-content-between">
            <div className="flex-grow-1">
              <span>{cat}{cell || row.description || '-'}</span>

              {/* Show per-item product list — only items with a product assigned */}
              {hasItems && materialItems.filter(i => i.recommended_product_id).map(item => (
                <div key={item.id} className="small mt-1 text-success">
                  <i className="fa-sharp fa-regular fa-check mr-1"></i>
                  <strong>{item.label}:</strong> {item.recommended_product_brand
                    ? `${item.recommended_product_brand} - ${item.recommended_product_name}`
                    : item.recommended_product_name}
                </div>
              ))}

              {/* Legacy fallback: show service-level recommended product */}
              {hasRecommendedProduct && (
                <div className="small text-success mt-1">
                  <i className="fa-sharp fa-regular fa-check mr-1"></i>
                  <strong>Use:</strong> {recommendedProductDisplay}
                </div>
              )}
            </div>

            {/* Cube button - always opens ServiceItemsModal */}
            {onSelectProduct && (
              <button
                type="button"
                className={`btn btn-sm ml-2 ${allItemsAssigned ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelectProduct(row);
                }}
                title={allItemsAssigned ? 'All items assigned' : 'Manage service items'}
                style={{ padding: '2px 6px', flexShrink: 0 }}
              >
                <i className={`fa-sharp fa-regular ${allItemsAssigned ? 'fa-check' : 'fa-cube'}`}></i>
              </button>
            )}
          </div>
        </div>
      );
    }
  },
  {
    dataField: "service_amount",
    text: "Amount",
    formatter: (cell, row) => formatServiceAmount(row)
  },
  { dataField: "service_duration", text: "Duration" }
];

const getServiceStatusColumns = () => [
  {
    dataField: "description",
    text: "Service",
    formatter: (cell, row) => {
      const cat = row.service_category ? `${row.service_category} - ` : '';
      return `${cat}${cell || '-'}`;
    }
  },
  { dataField: "Status", text: "Status" }
];

const getOfferColumns = () => [
  { dataField: "installerName", text: "Installer" },
  { dataField: "startDateString", text: "Date to Start" }
];

const getWorkServiceColumns = (technicians, onAssignTechnician, onEditInstructions, requestId, onShowMaterials, onSelectProduct, categoryHasProducts, onSplitAssignment) => [
  {
    dataField: "custom_description",
    text: "Service",
    formatter: (cell, row) => {
      // Check if actual materials have been collected
      const hasMaterials = row.materials && row.materials.length > 0;

      // Check if service has items (new model)
      const hasItems = row.items && row.items.length > 0;
      const materialItems = hasItems ? row.items.filter(i => !i.type || i.type === 'material') : [];
      const allItemsAssigned = materialItems.length > 0 && materialItems.every(i => i.recommended_product_id);

      // Legacy: check if recommended product is set (service-level)
      const hasRecommendedProduct = !hasItems && row.recommended_product_id && row.recommended_product_name;
      const recommendedProductDisplay = hasRecommendedProduct
        ? (row.recommended_product_brand
            ? `${row.recommended_product_brand} - ${row.recommended_product_name}`
            : row.recommended_product_name)
        : null;

      // Get materials display text
      const getMaterialsDisplay = () => {
        if (row.materials && row.materials.length > 0) {
          const m = row.materials[0];
          if (m.brand && m.product_name) return `${m.brand} - ${m.product_name}`;
          if (m.product_name) return m.product_name;
        }
        return 'Materials recorded';
      };

      const cat = row.service_category ? `${row.service_category} - ` : '';

      return (
        <div>
          <div className="d-flex align-items-start justify-content-between">
            <div className="flex-grow-1">
              <span>{cat}{cell || row.description || '-'}</span>

              {/* Show what was actually used (materials collected) */}
              {hasMaterials && (
                <div className="small text-info mt-1">
                  <i className="fa-sharp fa-regular fa-cubes mr-1"></i>
                  <strong>Used:</strong> {getMaterialsDisplay()}
                </div>
              )}

              {/* Show per-item product list — only items with a product assigned */}
              {!hasMaterials && hasItems && materialItems.filter(i => i.recommended_product_id).map(item => (
                <div key={item.id} className="small mt-1 text-success">
                  <i className="fa-sharp fa-regular fa-check mr-1"></i>
                  <strong>{item.label}:</strong> {item.recommended_product_brand
                    ? `${item.recommended_product_brand} - ${item.recommended_product_name}`
                    : item.recommended_product_name}
                </div>
              ))}

              {/* Legacy fallback: show service-level recommended product */}
              {!hasMaterials && hasRecommendedProduct && (
                <div className="small text-success mt-1">
                  <i className="fa-sharp fa-regular fa-check mr-1"></i>
                  <strong>Use:</strong> {recommendedProductDisplay}
                </div>
              )}
            </div>

            {/* Right-justified button area */}
            <div style={{ flexShrink: 0 }}>
              {/* Materials used - show cubes icon (takes priority) */}
              {hasMaterials && (
                <button
                  type="button"
                  className="btn btn-sm btn-link p-0 ml-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (onShowMaterials) onShowMaterials(row);
                  }}
                  title="View materials used"
                >
                  <i className="fa-sharp fa-regular fa-cubes text-info"></i>
                </button>
              )}

              {/* Cube button - always opens ServiceItemsModal when no materials collected */}
              {!hasMaterials && onSelectProduct && (
                <button
                  type="button"
                  className={`btn btn-sm ml-2 ${allItemsAssigned ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelectProduct(row);
                  }}
                  title={allItemsAssigned ? 'All items assigned' : 'Manage service items'}
                  style={{ padding: '2px 6px' }}
                >
                  <i className={`fa-sharp fa-regular ${allItemsAssigned ? 'fa-check' : 'fa-cube'}`}></i>
                </button>
              )}
            </div>
          </div>
        </div>
      );
    }
  },
  {
    dataField: "service_amount",
    text: "Amount",
    formatter: (cell, row) => formatServiceAmount(row)
  },
  { dataField: "service_duration", text: "Duration" },
  { dataField: "service_state", text: "State" },
  // Technician assignment column - only show if technicians exist
  ...(technicians && technicians.length > 0 ? [{
    dataField: "assigned_technician_id",
    text: "Lead tech",
    formatter: (cell, row) => {
      const ta = row.tech_assignment;
      const totalTaskCount = ta?.total_task_count ?? 0;
      // Splitting is only meaningful with 2+ steps and 2+ techs.
      const splitEligible = totalTaskCount >= 2 && technicians.length >= 2;

      // Override the picker's displayed label to reflect per-step state.
      // 'single' → tech name (cell holds lead id); 'mixed'/'partial' → synthetic
      // label so the row honestly reflects what's been assigned across steps.
      const isMixed = ta?.effective_state === 'mixed';
      const isPartial = ta?.effective_state === 'partial';
      const displayValue = isMixed || isPartial ? null : cell;
      const displayPlaceholder = isMixed
        ? 'Multiple techs'
        : isPartial
        ? 'Partially assigned'
        : 'Unassigned';

      let caption = null;
      if (ta) {
        if (isPartial) {
          const assigned = totalTaskCount - (ta.unassigned_task_count ?? 0);
          caption = `${assigned} of ${totalTaskCount} steps assigned`;
        } else if (isMixed) {
          caption = `${ta.techs?.length ?? 0} techs across ${totalTaskCount} steps`;
        } else if (ta.effective_state === 'none' && totalTaskCount > 0) {
          caption = 'Not assigned';
        }
      }

      const openSplit = (e) => {
        if (e) e.stopPropagation();
        if (onSplitAssignment) onSplitAssignment(row);
      };

      return (
        <div>
          <div className="d-flex align-items-center">
            <TechPicker
              technicians={technicians}
              value={displayValue}
              placeholder={displayPlaceholder}
              onChange={(techId) => onAssignTechnician(requestId, row.service_id, techId, row.id)}
              onSplit={splitEligible ? () => openSplit() : undefined}
            />
            {/* Instructions icon - only show if assigned */}
            {cell && (
              <button
                type="button"
                className="btn btn-sm btn-link p-0 ml-2"
                onClick={(e) => {
                  e.stopPropagation();
                  onEditInstructions(row);
                }}
                title={row.technician_instructions ? "Edit instructions" : "Add instructions"}
              >
                <i className={`fa-sharp fa-regular fa-sticky-note ${row.technician_instructions ? 'text-info' : 'text-muted'}`}></i>
              </button>
            )}
          </div>
          {caption && (
            <small
              className="text-muted d-block mt-1"
              style={{ cursor: splitEligible ? 'pointer' : 'default', textDecoration: splitEligible ? 'underline' : 'none' }}
              onClick={splitEligible ? openSplit : undefined}
            >
              {caption}
            </small>
          )}
        </div>
      );
    }
  }] : [])
];

// Basic work columns without assignment (for technicians viewing their own work)
const getBasicWorkServiceColumns = (onShowMaterials) => [
  {
    dataField: "custom_description",
    text: "Service",
    formatter: (cell, row) => {
      const hasMaterials = row.materials && row.materials.length > 0;
      const cat = row.service_category ? `${row.service_category} - ` : '';
      return (
        <div className="d-flex align-items-center">
          <span>{cat}{cell || row.description || '-'}</span>
          {hasMaterials && (
            <button
              type="button"
              className="btn btn-sm btn-link p-0 ml-2"
              onClick={(e) => {
                e.stopPropagation();
                if (onShowMaterials) onShowMaterials(row);
              }}
              title="View materials used"
            >
              <i className="fa-sharp fa-regular fa-cubes text-info"></i>
            </button>
          )}
        </div>
      );
    }
  },
  {
    dataField: "service_amount",
    text: "Amount",
    formatter: (cell, row) => formatServiceAmount(row)
  },
  { dataField: "service_duration", text: "Duration" },
  { dataField: "service_state", text: "State" }
];
// Helper Functions
const isEmpty = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

const calculateExistingCommitments = (calendarDays, currentRequestId = null) => {
  let existingCommitmentDates = [];
  const today = moment().startOf('day');
  
  for (let c = 0; c < calendarDays.length; c++) {
    const workDate = moment(calendarDays[c].workDate).startOf('day');
    const isCurrentJob = currentRequestId && calendarDays[c].requestId === currentRequestId;
    
    // Only include commitments from today forward, with active status, excluding current job
    if (WORK_STATUSES.includes(calendarDays[c].workStatus) && 
        workDate.isSameOrAfter(today) &&
        !isCurrentJob) {
      existingCommitmentDates.push(
        new Date(workDate.format("MMMM D, YYYY"))
      );
    }
  }
  
  return existingCommitmentDates;
};

const getPaymentList = (installer, canUseSplitPayment, userAccess, requestType) => {
  // Dealer payments only support card-based methods.
  if (requestType === REQUEST_TYPES.DEALER) {
    return ["Pay Online", "Swipe Card"];
  }

  let basePayList = ["Check", "Cash", "Pay Online", "Swipe Card"];

  if (canUseSplitPayment) {
    basePayList = ["Split Payment", ...basePayList];
  }

  // Swipe Card is offered whenever the installer is Stripe-enabled. The actual
  // reader for the selected location is resolved live at charge time, so we no
  // longer gate on the legacy installer.stripe_location field (which the
  // per-location pairing flow doesn't populate). If the selected location has
  // no online reader, the swipe flow surfaces a clear error at click time.
  const stripeEnabled = installer.stripe_account_id && installer.onboarding_complete;
  return !stripeEnabled
    ? (canUseSplitPayment ? ["Split Payment", "Check", "Cash", "Pay Online", "Settle"] : ["Check", "Cash", "Pay Online", "Settle"])
    : basePayList;
};

const prepareServiceStatusData = (services) => {
  return services.map(service => ({
    service_id: service.service_id,
    service_category: service.service_category,
    description: service.description,
    Status: _.capitalize(service.service_state)
  }));
};

// Reusable Components
const ServiceTable = ({ data, columns, keyField = "service_id", selectRow, rowEvents }) => {
  const tableProps = {
    keyField,
    data,
    columns
  };
  
  // Only add selectRow if it's provided and not null
  if (selectRow) {
    tableProps.selectRow = selectRow;
  }
  
  // Only add rowEvents if it's provided and not null
  if (rowEvents) {
    tableProps.rowEvents = rowEvents;
  }
  
  return (
    <div className="table-responsive jv-bt-table">
      <BootstrapTable {...tableProps} />
    </div>
  );
};

// REPLACE the existing AvailabilityAlert component in requestimateState.jsx

const AvailabilityAlert = ({ availability, calendarDays, requestId, selectedDate }) => {
  if (!availability) return null;
  
  const selectedDateStr = moment(selectedDate).format("YYYY-MM-DD");
  const suggestedDateStr = moment(availability.nextStart).format("YYYY-MM-DD");
  const isUserOverride = selectedDateStr !== suggestedDateStr;
  
  // Check for conflicts on selected date
  const conflictsOnSelectedDate = calendarDays?.filter(entry => 
    moment(entry.workDate).format("YYYY-MM-DD") === selectedDateStr && 
    ['booked', 'started'].includes(entry.workStatus) &&
    entry.requestId !== requestId
  ).length || 0;
  
  const getAlertType = () => {
    if (conflictsOnSelectedDate > 0) return 'warning';
    if (availability.canFit !== false) return 'success';
    return 'info';
  };
  
  const getCapacityMessage = () => {
    if (conflictsOnSelectedDate > 0) {
      return `⚠️ ${conflictsOnSelectedDate} confirmed job(s) on this date - schedule adjustment may be needed`;
    }
    
    if (availability.canFit !== false) {
      return "✅ Fits within normal capacity";
    }
    
    return "ℹ️ May require working over normal capacity";
  };
  
  return (
    <div className="form-row justify-content-md-center mb-3">
      <div className="col-md-8">
        <div className={`alert alert-${getAlertType()}`}>
          <strong><i className="fa-sharp fa-regular fa-calendar mr-1"></i> Selected Date:</strong> {moment(selectedDate).format("MMM DD, YYYY")}
          {availability.totalJobDays && availability.totalJobDays > 1 && (
            <span> ({availability.totalJobDays}-day job)</span>
          )}
          
          <div style={{ margin: "8px 0" }}>
            {getCapacityMessage()}
          </div>
          
          {/* Show suggestion if different from selection */}
          {isUserOverride && (
            <div style={{ color: "#6c757d", fontSize: "14px" }}>
              💡 Suggested date: {moment(availability.nextStart).format("MMM DD, YYYY")} 
              (optimal fit)
            </div>
          )}
                    
          {/* Capacity details if available */}
          {availability.availableSlots !== undefined && (
            <div style={{ fontSize: "12px", color: "#6c757d", marginTop: "5px" }}>
              Capacity: {availability.availableSlots} of {availability.availableSlots + (availability.existingJobs || 0)} slots available
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// REPLACE the DatePickerSection component in requestimateState.jsx with this:

const DatePickerSection = ({
  sDate,
  minDate,
  maxDate,
  exclude,
  existingCommitmentDates,
  onStartDateChange,
  label = "Pick Start Date",
  closedDays = [],  // Day-of-week numbers where location is closed (0=Sunday)
  blockedDates = [] // Specific dates that are blocked (holidays, vacations) as strings 'YYYY-MM-DD'
}) => {
  // Convert blockedDates strings to Date objects for excludeDates prop
  const blockedDateObjects = React.useMemo(() =>
    blockedDates.map(dateStr => moment(dateStr).toDate()),
    [blockedDates]
  );

  // Combine exclude prop with blocked dates
  const allExcludedDates = React.useMemo(() =>
    [...(exclude || []), ...blockedDateObjects],
    [exclude, blockedDateObjects]
  );

  // Memoize the date picker to prevent unnecessary re-renders
  /* eslint-disable react-hooks/exhaustive-deps */
  const memoizedDatePicker = React.useMemo(() => (
    <DatePicker
      selected={sDate}
      onChange={onStartDateChange}
      minDate={minDate}
      maxDate={maxDate}
      excludeDates={allExcludedDates}
      highlightDates={existingCommitmentDates}
      filterDate={(date) => {
        // Filter out days the location is closed (recurring weekly closures)
        const dayOfWeek = moment(date).day(); // 0=Sunday, 1=Monday, etc.
        return !closedDays.includes(dayOfWeek);
      }}
      dateFormat="MMMM d, yyyy"
      className="form-control"
      placeholderText="Click to select date"
      showPopperArrow={false}
      popperClassName="date-picker-popper"
      calendarClassName="date-picker-calendar"
    />
  ), [
    moment(sDate).format("YYYY-MM-DD"), // Use string comparison for dates
    moment(minDate).format("YYYY-MM-DD"),
    maxDate ? moment(maxDate).format("YYYY-MM-DD") : null,
    allExcludedDates.length, // Track all excluded dates
    existingCommitmentDates.length, // Just track array length
    closedDays.length, // Track closed days changes
    onStartDateChange
  ]);
  /* eslint-enable react-hooks/exhaustive-deps */

  return (
    <div className="mt-4 mb-4">
      <div className="row">
        <div className="col">
          <form className="form-row justify-content-md-center">
            <div className="form-group col-lg-2 text-center">
              <label className="bold">{label}</label>
            </div>
            <div className="form-group col-lg-4">
              <div className="input-group">
                {memoizedDatePicker}
                <div className="input-group-append">
                  <span className="input-group-text">
                    <i className="fa-sharp fa-regular fa-calendar" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ onClick, className, disabled = false, children, userAccess }) => {
  if (userAccess === USER_ACCESS_ASSIST) return null;
  
  return (
    <button
      type="button"
      onClick={onClick}
      className={className}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

const VehicleInfo = ({ request, scheduledDate }) => {
  // Check if VIN is valid (not system-generated NV or OT)
  const hasValidVin = request.vin &&
    !request.vin.toUpperCase().startsWith('NV') &&
    !request.vin.toUpperCase().startsWith('OT');

  // scheduledDate is already constructed in the location's timezone by the
  // parent (see scheduledStartDate). For mobile bookings the moment carries
  // a real time-of-day; for fixed shop it's midnight at the location.
  let scheduledLabel;
  if (scheduledDate) {
    const hasTime = scheduledDate.hour() !== 0 || scheduledDate.minute() !== 0;
    scheduledLabel = scheduledDate.format(
      hasTime ? "dddd, MMMM D, YYYY [at] h:mm A" : "dddd, MMMM D, YYYY"
    );
  } else {
    scheduledLabel = convertFromUTC(request.availableDate).format("dddd, MMMM D, YYYY");
  }

  return (
    <div className="mt-4 mb-4">
      <h4 className="text-primary mb-3">
        <i className="fa-sharp fa-regular fa-calendar-alt mr-2"></i>
        Scheduled: {scheduledLabel}
      </h4>
      {hasValidVin && (
        <p className="text-muted">
          <strong>VIN:</strong> {request.vin}
        </p>
      )}
    </div>
  );
};

const SplitPaymentModal = ({
  show,
  onHide,
  request,
  invoice,
  collectedPayments,
  remainingBalance,
  splitPaymentAmount,
  selectedSplitMethod,
  splitCheckNumber,
  isProcessingSplitPayment,
  splitPaymentError,
  onSplitMethodChange,
  onSplitAmountChange,
  onSplitCheckNumberChange,
  onCollectSplitPayment,
  userAccess
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Split Payment</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="split-payment-container">
          {/* Deposit Credit Display */}
          {request.depositAmount > 0 && (
            <div className="row mb-3">
              <div className="col-12">
                <div className="alert alert-info text-center">
                  <strong>Deposit Credit Applied: ${request.depositAmount.toFixed(2)}</strong>
                </div>
              </div>
            </div>
          )}

          {/* Invoice Totals */}
          <div className="row mb-3">
            <div className="col-12">
              <div className="split-payment-totals p-3 bg-light rounded">
                <div className="d-flex justify-content-between mb-2">
                  <span>Subtotal:</span>
                  <span>${request.requestTotal?.toFixed(2)}</span>
                </div>
                {request.requestDiscount > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span>Discount:</span>
                    <span className="text-success">-${request.requestDiscount.toFixed(2)}</span>
                  </div>
                )}
                {request.requestTaxes > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span>Sales Tax:</span>
                    <span>${request.requestTaxes.toFixed(2)}</span>
                  </div>
                )}
                <hr />
                <div className="d-flex justify-content-between mb-2">
                  <span className="font-weight-bold">Total Amount Due:</span>
                  <span className="font-weight-bold">
                    ${((request.requestTotal - (request.requestDiscount || 0)) + (request.requestTaxes || 0)).toFixed(2)}
                  </span>
                </div>
                {request.depositAmount > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span>Deposit Credit:</span>
                    <span className="text-success">-${request.depositAmount.toFixed(2)}</span>
                  </div>
                )}
                {collectedPayments.length > 0 && (
                  <div className="d-flex justify-content-between mb-2">
                    <span>Payments Collected:</span>
                    <span className="text-success">
                      -${collectedPayments.reduce((sum, p) => sum + (p.payment_amount || p.amount || p.invoice_amount || 0), 0).toFixed(2)}
                    </span>
                  </div>
                )}
                <hr />
                <div className="d-flex justify-content-between">
                  <span className="font-weight-bold">Remaining Balance:</span>
                  <span className="font-weight-bold text-primary">
                    ${remainingBalance?.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Collected Payments List */}
          {collectedPayments.length > 0 && (
            <div className="row mb-3">
              <div className="col-12">
                <div className="p-3 border rounded bg-white">
                  <h6 className="font-weight-bold mb-3">Collected Payments:</h6>
                  {collectedPayments.map((payment, index) => (
                    <div key={payment.payment_id || index} className="d-flex justify-content-between align-items-center py-2 border-bottom">
                      <div>
                        <strong>Payment {index + 1}</strong>
                        <br />
                        <small className="text-muted">
                          Method: {payment.payment_method}
                          {payment.check_number && ` | Check #${payment.check_number}`}
                          {' | Status: '}
                          <span className={`badge ${
                            (payment.payment_state === 'paid' || (payment.payment_state === 'pending' && payment.payment_method?.toLowerCase() === 'cash'))
                              ? 'badge-success'
                              : 'badge-warning'
                          }`}>
                            {(payment.payment_state === 'pending' && payment.payment_method?.toLowerCase() === 'cash')
                              ? 'paid'
                              : payment.payment_state}
                          </span>
                        </small>
                      </div>
                      <span className="font-weight-bold text-success">
                        ${(payment.payment_amount || payment.amount || payment.invoice_amount || 0).toFixed(2)}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

          {/* Next Payment Form */}
          {remainingBalance > 0 && (
            <div className="row">
              <div className="col-12">
                <div className="split-payment-form p-3 border rounded">
                  <h6 className="font-weight-bold mb-3">Collect Next Payment</h6>

                  {/* Error Display */}
                  {splitPaymentError && (
                    <div className="alert alert-danger">
                      {splitPaymentError}
                    </div>
                  )}

                  {/* Payment Method Selection */}
                  <div className="form-group">
                    <label className="font-weight-bold">
                      Payment Method <span className="text-danger">*</span>
                    </label>
                    <div className="btn-group d-flex" role="group">
                      <button
                        type="button"
                        className={`btn ${selectedSplitMethod === 'Terminal' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onSplitMethodChange('Terminal')}
                      >
                        Terminal
                      </button>
                      <button
                        type="button"
                        className={`btn ${selectedSplitMethod === 'Online' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onSplitMethodChange('Online')}
                      >
                        Online Card
                      </button>
                      <button
                        type="button"
                        className={`btn ${selectedSplitMethod === 'Cash' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onSplitMethodChange('Cash')}
                      >
                        Cash
                      </button>
                      <button
                        type="button"
                        className={`btn ${selectedSplitMethod === 'Check' ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onSplitMethodChange('Check')}
                      >
                        Check
                      </button>
                    </div>
                  </div>

                  {/* Online Payment Warning */}
                  {selectedSplitMethod === 'Online' && (
                    <div className="alert alert-warning mt-2 mb-0">
                      <i className="fa-sharp fa-regular fa-exclamation-triangle mr-2"></i>
                      <strong>Note:</strong> Customer will receive invoice via email.
                      Payment is not guaranteed before they leave.
                      Use Terminal if available.
                    </div>
                  )}

                  {/* Payment Amount Input */}
                  <div className="form-group">
                    <label className="font-weight-bold">
                      Payment Amount <span className="text-danger">*</span>
                    </label>
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">$</span>
                      </div>
                      <input
                        type="number"
                        className="form-control"
                        value={splitPaymentAmount}
                        onChange={(e) => onSplitAmountChange(e.target.value)}
                        placeholder="0.00"
                        min="0"
                        max={remainingBalance}
                        step="0.01"
                      />
                    </div>
                    <small className="form-text text-muted">
                      Maximum: ${remainingBalance?.toFixed(2)}
                    </small>
                  </div>

                  {/* Check Number Input - Only for Check payments */}
                  {selectedSplitMethod === 'Check' && (
                    <div className="form-group">
                      <label className="font-weight-bold">
                        Check Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={splitCheckNumber}
                        onChange={(e) => onSplitCheckNumberChange(e.target.value)}
                        placeholder="Enter check number"
                      />
                    </div>
                  )}

                  {/* Collect Payment Button */}
                  <div className="text-center mt-3">
                    <button
                      className="jv-btn jv-btn-primary btn-lg"
                      onClick={onCollectSplitPayment}
                      disabled={isProcessingSplitPayment || !selectedSplitMethod || !splitPaymentAmount}
                    >
                      {isProcessingSplitPayment ? (
                        <>
                          <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                          Processing...
                        </>
                      ) : (
                        `Collect Payment - $${parseFloat(splitPaymentAmount || 0).toFixed(2)}`
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Complete Button - Show when balance is $0 */}
          {remainingBalance === 0 && (
            <div className="row mt-3">
              <div className="col text-center">
                <div className="alert alert-success">
                  <strong>All payments collected! Invoice is fully paid.</strong>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Technician Instructions Modal Component
const TechnicianInstructionsModal = ({
  show,
  onHide,
  service,
  onSave,
  saving
}) => {
  const [instructions, setInstructions] = useState(service?.technician_instructions || '');

  // Reset instructions when service changes
  React.useEffect(() => {
    setInstructions(service?.technician_instructions || '');
  }, [service]);

  const handleSave = () => {
    onSave(service?.service_id, instructions);
  };

  // Build the service display string with category
  const serviceDisplay = service?.service_category
    ? `${service.service_category} - ${service?.custom_description || service?.description}`
    : service?.custom_description || service?.description;

  // Build recommended product display
  const hasRecommendedProduct = service?.recommended_product_id && service?.recommended_product_name;
  const recommendedProductDisplay = hasRecommendedProduct
    ? (service?.recommended_product_brand
        ? `${service.recommended_product_brand} - ${service.recommended_product_name}`
        : service.recommended_product_name)
    : null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Technician Instructions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label className="font-weight-bold">
            Service: {serviceDisplay}
          </label>
          {hasRecommendedProduct && (
            <div className="text-success mb-2">
              <i className="fa-sharp fa-regular fa-check mr-1"></i>
              <strong>Recommended Product:</strong> {recommendedProductDisplay}
            </div>
          )}
          <textarea
            className="form-control"
            rows={4}
            value={instructions}
            onChange={(e) => setInstructions(e.target.value)}
            placeholder="Add instructions for the technician..."
            disabled={saving}
          />
          <small className="form-text text-muted">
            These notes will be visible to the assigned technician in their My Work view.
          </small>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={saving}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSave} disabled={saving}>
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
              Saving...
            </>
          ) : (
            'Save Instructions'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Dealer Reschedule Modal Component
const DealerRescheduleModal = ({
  show,
  onHide,
  request,
  onConfirm,
  availableDate,
  dueDate,
  onAvailableDateChange,
  onDueDateChange,
  locationTz,
}) => {
  // Handle available date change with smart due date adjustment
  const handleAvailableDateChange = (date) => {
    onAvailableDateChange(date);

    // If the new available date is after the current due date,
    // automatically update due date to match available date
    if (dueDate && moment(date).isAfter(moment(dueDate))) {
      onDueDateChange(date);
    }
  };

  // "Today" anchored to the LOCATION's timezone — EDT viewer of an HST
  // dealer uses HST's calendar.
  const today = moment.tz(locationTz || moment.tz.guess()).startOf('day').toDate();

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Reschedule Job</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="reschedule-modal-container">
          <div className="alert alert-info">
            <strong>Current Request Dates:</strong>
            <br />
            Available Date: {convertFromUTC(request.availableDate).format("MM/DD/YYYY")}
            <br />
            Due Date: {convertFromUTC(request.dueDate).format("MM/DD/YYYY")}
          </div>

          <div className="form-group">
            <label htmlFor="availableDate" className="font-weight-bold">
              Available Date <span className="text-danger">*</span>
            </label>
            <DatePicker
              id="availableDate"
              selected={availableDate}
              onChange={handleAvailableDateChange}
              minDate={today}
              dateFormat="MM/dd/yyyy"
              className="form-control"
              placeholderText="Select available date"
            />
            <small className="form-text text-muted">
              When the vehicle will be available for the specialist to start work
            </small>
          </div>

          <div className="form-group mt-3">
            <label htmlFor="dueDate" className="font-weight-bold">
              Due Date <span className="text-danger">*</span>
            </label>
            <DatePicker
              id="dueDate"
              selected={dueDate}
              onChange={onDueDateChange}
              minDate={availableDate || today}
              dateFormat="MM/dd/yyyy"
              className="form-control"
              placeholderText="Select due date"
            />
            <small className="form-text text-muted">
              Deadline for completing the work
            </small>
          </div>

          {availableDate && dueDate && moment(dueDate).isBefore(availableDate) && (
            <div className="alert alert-danger mt-3">
              Due date cannot be before available date
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="warning"
          onClick={onConfirm}
          disabled={!availableDate || !dueDate || moment(dueDate).isBefore(availableDate)}
        >
          Update Schedule
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const RequestimateState = (props) => {
  // Detect if mobile device
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const {
    userType,
    typeId,
    userAccess,
    userRole,
    installer,
    request,
    services,
    notes,
    displayedList,
    offers,
    routerHistory,
    invoice,
    calendarDays,
    startDate,
    onStartDateChange,
    rowSelected,
    onDelete,
    selectedInstaller,
    selectedService,
    onAccept,
    onAcceptEstimate,
    onCompleteEstimate,
    onReject,
    onAssign,
    onReschedule,
    onDealerReschedule,
    canDealerReschedule,
    onStart,
    onFinish,
    onComplete,
    onSelectService,
    onSelectInstaller,
    showDepositModal,
    onShowDepositModal,
    onHideDepositModal,
    onSaveDeposit,
    onEdit,
    reviewScore,
    onReviewScoreChange,
    onSettle,
    onResend,
    onReview,
    selectedPay,
    checkNumber,
    onPaymentChange,
    onCheckNumberChange,
    onPayment,
    onDeliver,
    showSwipe,
    closeSwipe,
    showPO,
    closePO,
    onAddPO,
    onPO,
    availability,
    // NEW PROPS for progress modal:
    paymentState,
    paymentError,
    onRetryPayment,
    onCancelTerminal,
    onTransferLocation,

    // Split Payment Props
    collectedPayments,
    splitPaymentAmount,
    selectedSplitMethod,
    splitCheckNumber,
    isProcessingSplitPayment,
    splitPaymentError,
    remainingBalance,
    canUseSplitPayment,
    onCollectSplitPayment,
    onSplitMethodChange,
    onSplitAmountChange,
    onSplitCheckNumberChange,
    showInvoiceLinkModal,
    currentInvoiceLink,
    onCloseInvoiceLinkModal,
    onSendQuote,

    // Technician Assignment Props
    technicians,
    onAssignTechnician,
    onSplitAssignment,
    onSaveInstructions,
    savingInstructions,

    // Product Selection Props
    categoryHasProducts,
    onSelectProduct,

    // Multi-location Props
    locations,

    // CarFax Data Props
    checkinOdometerReading,
    checkinPlate,
    checkinCarfaxOptOut,
    onCarfaxOptOut,

    // Draft invoice (Invoice at Payment) props
    isMaterializing,
    onResendDraftEmail,
    onVoidInvoice,
  } = props;

  // Filter technicians to those assigned to the request's location
  const requestLocId = request?.location_id || request?.locationId;
  const locationTechnicians = (technicians || []).filter(tech => {
    if (!requestLocId || requestLocId === 0 || requestLocId === '0') return true; // unclaimed — show all
    const techLocId = tech.location_id || tech.locationId;
    return !techLocId || String(techLocId) === String(requestLocId);
  });

  // Local state for completion photos modal
  const [showCompletionPhotos, setShowCompletionPhotos] = useState(false);
  const [showSplitPaymentModal, setShowSplitPaymentModal] = useState(false);

  // Copy-to-clipboard state and helper
  const [copiedField, setCopiedField] = useState(null);
  const copyToClipboard = (value, fieldName) => {
    if (!value) return;
    navigator.clipboard.writeText(value).then(() => {
      setCopiedField(fieldName);
      setTimeout(() => setCopiedField(null), 1500);
    }).catch(() => {
      const textarea = document.createElement('textarea');
      textarea.value = value;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopiedField(fieldName);
      setTimeout(() => setCopiedField(null), 1500);
    });
  };


  // Handler to open service items modal (via parent)
  const handleOpenProductSelection = (service) => {
    if (onSelectProduct) {
      onSelectProduct(service);
    }
  };

  // Local state for technician instructions modal
  const [showInstructionsModal, setShowInstructionsModal] = useState(false);
  const [editingService, setEditingService] = useState(null);

  // Local state for materials view modal
  const [showMaterialsViewModal, setShowMaterialsViewModal] = useState(false);
  const [materialsViewService, setMaterialsViewService] = useState(null);

  // Handler for opening instructions modal
  const handleEditInstructions = (service) => {
    setEditingService(service);
    setShowInstructionsModal(true);
  };

  // Handler for saving instructions
  const handleSaveInstructions = (serviceId, instructions) => {
    onSaveInstructions(request.requestId, serviceId, instructions);
    setShowInstructionsModal(false);
    setEditingService(null);
  };

  // Handler for showing materials used
  const handleShowMaterials = (service) => {
    setMaterialsViewService(service);
    setShowMaterialsViewModal(true);
  };

  // Local state for dealer reschedule modal
  const [showDealerRescheduleModal, setShowDealerRescheduleModal] = useState(false);
  const [rescheduleAvailableDate, setRescheduleAvailableDate] = useState(null);
  const [rescheduleDueDate, setRescheduleDueDate] = useState(null);

  // Mobile booking — appointment_start (moment with time) when scheduling a
  // mobile-location job. Lifted here so the "Book Job" handler can read it
  // and the slot-pick component can write it. Initialized from the request's
  // existing scheduledStart when present (covers the reschedule-back-to-NEW
  // case where the prior slot is the natural starting point).
  //
  // TZ wrinkle: mysql2 with timezone:'Z' returns DATETIME values labeled as
  // UTC, but the server stores them as wall-clock at the location. Extract
  // the wall-clock via moment.utc, then re-anchor in the location's TZ so
  // the form sees the right date + time-of-day.
  const initialLocationTz = props.currentLocation?.timezone || moment.tz.guess();
  const [appointmentStart, setAppointmentStart] = useState(() => {
    if (!request?.scheduledStart) return null;
    const wallClock = moment.utc(request.scheduledStart);
    if (!wallClock.isValid()) return null;
    return moment.tz(
      wallClock.format('YYYY-MM-DD HH:mm:ss'),
      'YYYY-MM-DD HH:mm:ss',
      initialLocationTz
    );
  });

  const payList = getPaymentList(installer, canUseSplitPayment, userAccess, request.requestType);

  const handleCompletionPhotosSuccess = () => {
    // Refresh the page or reload request data after successful upload
    window.location.reload();
  };

  // Early returns for empty state
  if (isEmpty(request)) {
    return null;
  }

  const check = displayedList.filter(
    (item) => item.requestId === request.requestId
  );

  if (check.length === 0) {
    return null;
  }

  // Prepare data
  const displayOffers = prepareOffersData(offers);

  const noteText = notes.length > 0 && notes[0].note_text.length > 1
    ? notes[0].note_text 
    : "None";

  // Filter offers for dealer display
  if (userType === USER_TYPES.DEALER) {
    const filteredOffers = offers.filter(
      (offer) => offer.currentStatus === "accepted"
    );
    displayOffers.splice(0, displayOffers.length, ...prepareOffersData(filteredOffers));
  }

  // Scheduled dates come from request_offered (via server JOIN). Server stores
  // wall-clock-at-location in DATETIME; mysql2 (timezone:'Z') hands it back as
  // a UTC-labelled ISO but the value is wall-clock. Extract wall-clock via
  // moment.utc().format(), then re-anchor in the location's TZ — same pattern
  // calendar.jsx and the appointmentStart init use. Using moment.tz(iso, tz)
  // here would (wrongly) treat the value as a real UTC instant and shift it.
  const locationTz = props.currentLocation?.timezone || moment.tz.guess();
  const scheduledStartDate = request.scheduledStart
    ? moment.tz(
        moment.utc(request.scheduledStart).format('YYYY-MM-DD HH:mm:ss'),
        'YYYY-MM-DD HH:mm:ss',
        locationTz
      )
    : moment.tz(
        moment.utc(request.availableDate).format('YYYY-MM-DD HH:mm:ss'),
        'YYYY-MM-DD HH:mm:ss',
        locationTz
      );

// Date calculations - stabilized with string comparisons.
// All "today" anchors use the LOCATION's timezone so EDT viewers of an
// HST-located request see HST's calendar, not their browser's.
const startDateStr = moment(startDate).format("YYYY-MM-DD");
const todayStr = moment.tz(locationTz).format("YYYY-MM-DD");

// Universal minimum date (can't book in the past) - use string comparison first
let sDate;
if (startDateStr < todayStr) {
  sDate = moment.tz(locationTz).startOf('day').toDate();
} else {
  sDate = moment(startDate).toDate();
}

// Dealer dueDate is informational — AvailabilityAlert surfaces slips.
// Don't hard-cap the picker; installers need to reschedule past the
// dealer's window when the original date can't be hit.
let maxDate = null;

// Use consistent date objects to prevent re-renders
const minDate = moment.tz(locationTz).startOf('day').toDate();

// Remove the excessive logging that was causing console spam
/* console.log("🎯 Final date calculation:", {
  userSelected: startDateStr,
  finalDate: moment(sDate).format("YYYY-MM-DD"),
  jobType: request.requestType
});*/

  //console.log("User Type : ", userType);
  //console.log("Request Type : ", request.requestType);
  //console.log("Current State : ", request.currentState);
  //console.log("Assigned To : ", request.assignedTo);

  // Job services setup
  const thisJobServices = Array.from(
    calendarDays.filter((day) => day.requestId === request.requestId)
  );
  const thisJob = _.orderBy(thisJobServices, "serviceId", "asc");

  // Calculate exclude dates and commitments
const existingCommitmentDates = calculateExistingCommitments(calendarDays);

  // Invoice processing
  const workingInvoice = JSON.parse(JSON.stringify(invoice));

  //************************************************************************
  //***********************  Dealer Group (Read-Only) **********************
  //************************************************************************

// Dealer-group access (user_companies.location_id = 0) = read-only view.
// Sub-scoped dealer users (pinned to one dealership) fall through to the
// regular dealer flow below.
if (userType === USER_TYPES.DEALER && ScopeService.isDealerGroupUser()) {
  // Dealer group users see the same info as dealers but with no action buttons
  const services_ = [REQUEST_STATES.NEW, REQUEST_STATES.ANSWERED].includes(request.currentState)
    ? Array.from(services)
    : prepareServiceStatusData(services);
  const columns = [REQUEST_STATES.NEW, REQUEST_STATES.ANSWERED].includes(request.currentState)
    ? getDealerServiceColumns()
    : getServiceStatusColumns();

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          <ScheduleNotification request={request} calendarDays={calendarDays} />
          <ServiceTable
            data={services_}
            columns={columns}
          />
          <div className="text-muted mt-3" style={{ fontSize: '0.85rem' }}>
            <i className="fa-sharp fa-regular fa-eye mr-1" />
            Read-only view
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

  //************************************************************************
  //***************************  Dealer Pages ******************************
  //************************************************************************

if (request.currentState === REQUEST_STATES.NEW && userType === USER_TYPES.DEALER) {
  const services_ = Array.from(services);
  // Check if this dealer is configured to require contracts
  const dealerRequiresContracts = props.company?.customer_contract === 'Y';

  // Check if dealer can reschedule
  const rescheduleCheck = canDealerReschedule ? canDealerReschedule(request) : { canReschedule: false };

  const handleRescheduleClick = () => {
    // Initialize modal with current dates
    setRescheduleAvailableDate(moment(request.availableDate).toDate());
    setRescheduleDueDate(moment(request.dueDate).toDate());
    setShowDealerRescheduleModal(true);
  };

  const handleRescheduleConfirm = () => {
    onDealerReschedule(request, rescheduleAvailableDate, rescheduleDueDate);
    setShowDealerRescheduleModal(false);
  };

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          {/* Enhanced service table showing both specialist cost and customer retail price */}
          <ServiceTable
            data={services_}
            columns={getDealerServiceColumns()}
          />

          {/* Action Buttons - including contract button inline */}
          <div className="jv-btn-group-spaced">
            {/* Contract Button - Only if dealer requires contracts */}
            {dealerRequiresContracts && (
              request.contract_url ? (
                <ActionButton
                  onClick={() => fetchSignedUrl(request.requestId)}
                  className="jv-btn jv-btn-tertiary"
                  userAccess={userAccess}
                >
                  View Contract
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => window.location.href = `/contract/${request.requestId}`}
                  className="jv-btn jv-btn-primary"
                  userAccess={userAccess}
                >
                  Create Contract
                </ActionButton>
              )
            )}

            {/* Reschedule Button */}
            {rescheduleCheck.canReschedule && (
              <ActionButton
                onClick={handleRescheduleClick}
                className="jv-btn jv-btn-secondary"
                userAccess={userAccess}
              >
                Reschedule
              </ActionButton>
            )}

            <ActionButton
              onClick={() => onDelete(request)}
              className="jv-btn jv-btn-danger"
              userAccess={userAccess}
            >
              Delete
            </ActionButton>
          </div>
        </div>
      </div>

      {/* Dealer Reschedule Modal */}
      <DealerRescheduleModal
        show={showDealerRescheduleModal}
        onHide={() => setShowDealerRescheduleModal(false)}
        request={request}
        onConfirm={handleRescheduleConfirm}
        availableDate={rescheduleAvailableDate}
        dueDate={rescheduleDueDate}
        onAvailableDateChange={setRescheduleAvailableDate}
        onDueDateChange={setRescheduleDueDate}
        locationTz={locationTz}
      />
    </React.Fragment>
  );
}

// Answered request for Dealer - WITH CONTRACT OPTION
if (request.currentState === REQUEST_STATES.ANSWERED && userType === USER_TYPES.DEALER) {
  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    bgColor: "grey",
    onClick: (e, row, rowIndex) => {
      onSelectInstaller(row);
    },
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      onSelectInstaller(row);
    },
  };

  // Check if this dealer is configured to require contracts
  const dealerRequiresContracts = props.company?.customer_contract === 'Y';

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          <h5 className="card-title">
            Approve the work for the specialist to start
          </h5>
          <ServiceTable 
            data={displayOffers} 
            columns={getOfferColumns()}
            keyField="installerId"
            selectRow={selectRow}
            rowEvents={rowEvents}
          />
          
          {/* Action Buttons - including contract button inline */}
          <div className="jv-btn-group-spaced">
            {/* Contract Button - Only if dealer requires contracts */}
            {dealerRequiresContracts && (
              request.contract_url ? (
                <ActionButton
                  onClick={() => fetchSignedUrl(request.requestId)}
                  className="jv-btn jv-btn-tertiary"
                  userAccess={userAccess}
                >
                  View Contract
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => window.location.href = `/contract/${request.requestId}`}
                  className="jv-btn jv-btn-primary"
                  userAccess={userAccess}
                >
                  Create Contract
                </ActionButton>
              )
            )}

            <ActionButton
              onClick={() => onAssign(request, selectedInstaller)}
              className="jv-btn jv-btn-primary"
              disabled={!selectedInstaller}
              userAccess={userAccess}
            >
              Assign
            </ActionButton>

            <span className="jv-btn-group-divider" />

            <ActionButton
              onClick={() => onDelete(request)}
              className="jv-btn jv-btn-danger"
              userAccess={userAccess}
            >
              Delete
            </ActionButton>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

// RECEIVED state for Dealer - with reschedule option
  if (request.currentState === REQUEST_STATES.RECEIVED && userType === USER_TYPES.DEALER) {
    const services_ = prepareServiceStatusData(services);

    // Check if dealer can reschedule
    const rescheduleCheck = canDealerReschedule ? canDealerReschedule(request) : { canReschedule: false };

    const handleRescheduleClick = () => {
      // Initialize modal with current dates
      setRescheduleAvailableDate(moment(request.availableDate).toDate());
      setRescheduleDueDate(moment(request.dueDate).toDate());
      setShowDealerRescheduleModal(true);
    };

    const handleRescheduleConfirm = () => {
      onDealerReschedule(request, rescheduleAvailableDate, rescheduleDueDate);
      setShowDealerRescheduleModal(false);
    };

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <ScheduleNotification request={request} calendarDays={calendarDays} />
            <ServiceTable
              data={services_}
              columns={getServiceStatusColumns()}
            />

            {/* Reschedule Button */}
            {rescheduleCheck.canReschedule && (
              <div className="jv-btn-group-spaced">
                <ActionButton
                  onClick={handleRescheduleClick}
                  className="jv-btn jv-btn-secondary"
                  userAccess={userAccess}
                >
                  Reschedule
                </ActionButton>
              </div>
            )}
          </div>
        </div>

        {/* Dealer Reschedule Modal */}
        <DealerRescheduleModal
          show={showDealerRescheduleModal}
          onHide={() => setShowDealerRescheduleModal(false)}
          request={request}
          onConfirm={handleRescheduleConfirm}
          availableDate={rescheduleAvailableDate}
          dueDate={rescheduleDueDate}
          onAvailableDateChange={setRescheduleAvailableDate}
          onDueDateChange={setRescheduleDueDate}
          locationTz={locationTz}
        />
      </React.Fragment>
    );
  }

// Multiple states for Dealer showing service status (STARTED and FINISHED - no reschedule allowed)
  const dealerStatusStates = [ REQUEST_STATES.STARTED, REQUEST_STATES.FINISHED];
  if (dealerStatusStates.includes(request.currentState) && userType === USER_TYPES.DEALER) {
    const services_ = prepareServiceStatusData(services);

    //console.log("RequestimateState : service  :", services)
    //console.log("RequestimateState : service history :", history)

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <ScheduleNotification request={request} calendarDays={calendarDays} />
            <ServiceTable
              data={services_}
              columns={getServiceStatusColumns()}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
  
if (request.currentState === REQUEST_STATES.SCHEDULED && userType === USER_TYPES.DEALER) {
  const services_ = prepareServiceStatusData(services);
  const dealerRequiresContracts = props.company?.customer_contract === 'Y';

  // Check if dealer can reschedule
  const rescheduleCheck = canDealerReschedule ? canDealerReschedule(request) : { canReschedule: false };

  const handleRescheduleClick = () => {
    // Initialize modal with current dates
    setRescheduleAvailableDate(moment(request.availableDate).toDate());
    setRescheduleDueDate(moment(request.dueDate).toDate());
    setShowDealerRescheduleModal(true);
  };

  const handleRescheduleConfirm = () => {
    onDealerReschedule(request, rescheduleAvailableDate, rescheduleDueDate);
    setShowDealerRescheduleModal(false);
  };

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
<ScheduleNotification request={request} calendarDays={calendarDays} />
          <ServiceTable
            data={services_}
            columns={getServiceStatusColumns()}
          />

          {/* Contract functionality - available until work starts */}
          {dealerRequiresContracts && (
            <div>
              {!request.contract_url && (
                <div className="alert alert-warning mb-3">
                  <i className="fa-sharp fa-regular fa-exclamation-triangle"></i>
                  <strong> Contract Required:</strong> Work cannot begin until customer contract is created and signed.
                </div>
              )}

              {request.contract_url && (
                <div className="alert alert-success mb-3">
                  <i className="fa-sharp fa-regular fa-check-circle"></i>
                  <strong> Contract Ready:</strong> Customer contract is complete. Work can proceed.
                </div>
              )}
            </div>
          )}

          <div className="jv-btn-group-spaced">
            {/* Contract Action Button */}
            {dealerRequiresContracts && (
              request.contract_url ? (
                <ActionButton
                  onClick={() => fetchSignedUrl(request.requestId)}
                  className="jv-btn jv-btn-tertiary"
                  userAccess={userAccess}
                >
                  View Contract
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => window.location.href = `/contract/${request.requestId}`}
                  className="jv-btn jv-btn-primary"
                  userAccess={userAccess}
                >
                  Create Contract
                </ActionButton>
              )
            )}

            {/* Reschedule Button */}
            {rescheduleCheck.canReschedule && (
              <ActionButton
                onClick={handleRescheduleClick}
                className="jv-btn jv-btn-secondary"
                userAccess={userAccess}
              >
                Reschedule
              </ActionButton>
            )}
          </div>
        </div>
      </div>

      {/* Dealer Reschedule Modal */}
      <DealerRescheduleModal
        show={showDealerRescheduleModal}
        onHide={() => setShowDealerRescheduleModal(false)}
        request={request}
        onConfirm={handleRescheduleConfirm}
        availableDate={rescheduleAvailableDate}
        dueDate={rescheduleDueDate}
        onAvailableDateChange={setRescheduleAvailableDate}
        onDueDateChange={setRescheduleDueDate}
        locationTz={locationTz}
      />
    </React.Fragment>
  );
}

  // Finished job for Dealer - Review
  if (request.currentState === REQUEST_STATES.COLLECTED && userType === USER_TYPES.DEALER) {
    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <h5 className="card-title">Rate the installer work</h5>
            <div className="col-lg-12">
              <StarRatingComponent
                name="rate1"
                starCount={5}
                value={reviewScore}
                onStarClick={onReviewScoreChange}
                starColor="#ffb400"
                emptyStarColor="#e4e5e9"
                renderStarIcon={(index, value) => (
                  <i className={index <= value ? 'fa-sharp fa-solid fa-star' : 'fa-sharp fa-regular fa-star'} />
                )}
              />
            </div>
            <div className="jv-btn-group-spaced">
              <ActionButton
                onClick={() => onReview(request)}
                className="jv-btn jv-btn-primary"
                disabled={!reviewScore}
                userAccess={userAccess}
              >
                Submit Review
              </ActionButton>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }


  //************************************************************************
  //***************************  Installer Pages ***************************
  //************************************************************************

  // New Request display for Installer Estimate
// UPDATED LOGIC - Replace existing conditions

// 1. DISCOVERY JOBS (assigned_to = 0) - Require CLAIM action
const isDiscoveryJob = request.currentState === REQUEST_STATES.NEW && 
  userType === USER_TYPES.INSTALLER && 
  request.requestType === REQUEST_TYPES.DEALER && 
  request.assignedTo === 0;

// 2. DIRECT ASSIGNMENTS (assigned_to = specialist_id) - Just need BOOK action  
const isDirectAssignment = request.currentState === REQUEST_STATES.NEW && 
  userType === USER_TYPES.INSTALLER && 
  request.requestType === REQUEST_TYPES.DEALER && 
  request.assignedTo === parseInt(typeId); // Directly assigned to this specialist

// 3. RETAIL JOBS (installer creates their own) - Just need BOOK action
const isRetailJob = request.currentState === REQUEST_STATES.NEW && 
  userType === USER_TYPES.INSTALLER && 
  request.requestType === REQUEST_TYPES.INSTALLER;

// COMBINED logic for jobs that just need booking (not claiming)
const isInstallerNewRequest = isRetailJob || isDirectAssignment;

if (isInstallerNewRequest) {
  const services_ = prepareServiceData(services);
  const showTransferOption = canTransferJob(request, { installer_id: parseInt(typeId) }, userRole);

  return (
    <React.Fragment>
      <div className="card text-center">
        <div className="card-body">
          <ServiceTable
            data={services_}
            columns={getCustomServiceColumns(handleOpenProductSelection, categoryHasProducts)}
          />
        </div>
{isMobileLocation(props.currentLocation) ? (
  <MobileAppointmentForm
    currentStep={5}
    currentLocation={props.currentLocation}
    customerLat={request?.customer_address_lat ?? request?.latitude}
    customerLng={request?.customer_address_long ?? request?.longitude}
    services={services}
    appointmentStart={appointmentStart}
    onAppointmentChange={setAppointmentStart}
    excludeRequestId={request?.scheduledStart ? request.requestId : null}
  />
) : (
  <>
    <AvailabilityAlert
      availability={availability}
      calendarDays={calendarDays}
      requestId={request.requestId}
      selectedDate={sDate}
      jobType={request.requestType}
    />
    <DatePickerSection
      sDate={sDate}
      minDate={minDate}
      maxDate={maxDate}
      exclude={[]}
      existingCommitmentDates={existingCommitmentDates}
      onStartDateChange={onStartDateChange}
      label="Pick Start Date"
      closedDays={availability?.closedDays || []}
      blockedDates={availability?.blockedDates || []}
    />
  </>
)}

        <div className="row justify-content-center">
          <div className="col-12">
            <div className="jv-btn-group-spaced">
              {/* Group 1: Work the Estimate */}
              {request.requestType === 'installer' && (() => {
                const quoteSentAt = request.quoteSentAt || request.quote_sent_at;
                const quoteAcceptedAt = request.quoteAcceptedAt || request.quote_accepted_at;
                if (!quoteAcceptedAt) {
                  return (
                    <ActionButton
                      onClick={() => onSendQuote(request)}
                      className="jv-btn jv-btn-primary"
                      userAccess={userAccess}
                    >
                      {quoteSentAt ? 'Resend Estimate' : 'Send Estimate'}
                    </ActionButton>
                  );
                }
                return null;
              })()}
              <ActionButton
                onClick={() => onEdit(request)}
                className="jv-btn jv-btn-secondary"
                userAccess={userAccess}
              >
                Edit
              </ActionButton>
              {request.requestType === 'installer' && (
                <ActionButton
                  onClick={() => onShowDepositModal(request)}
                  className="jv-btn jv-btn-tertiary"
                  userAccess={userAccess}
                >
                  Set Deposit
                </ActionButton>
              )}

              <div className="jv-btn-group-divider">{'\u00A0'}</div>

              {/* Group 2: Move it Forward */}
              <ActionButton
                onClick={() => onAcceptEstimate(request, startDate, appointmentStart)}
                className="jv-btn jv-btn-primary"
                userAccess={userAccess}
                disabled={isMobileLocation(props.currentLocation) && !appointmentStart}
              >
                Book Job
              </ActionButton>
              {showTransferOption && isMultiLocation(locations) && (
                <ActionButton
                  onClick={() => onTransferLocation(request)}
                  className="jv-btn jv-btn-secondary"
                  userAccess={userAccess}
                >
                  Transfer
                </ActionButton>
              )}
              <ActionButton
                onClick={() => onCompleteEstimate(request, startDate)}
                className="jv-btn jv-btn-secondary"
                userAccess={userAccess}
              >
                Job Completed
              </ActionButton>

              <div className="jv-btn-group-divider">{'\u00A0'}</div>

              {/* Group 3: Remove */}
              <ActionButton
                onClick={() => onDelete(request)}
                className="jv-btn jv-btn-danger"
                userAccess={userAccess}
              >
                Delete
              </ActionButton>
            </div>

            {/* Deposit modal */}
            <DepositModal
              show={showDepositModal}
              onHide={onHideDepositModal}
              request={request}
              onSaveDeposit={onSaveDeposit}
            />
          </div>
        </div>
      </div>

    </React.Fragment>
  );
}

  // New request for Installer user for a dealer request (unassigned)

  if (isDiscoveryJob) {
    const services_ = prepareServiceData(services);

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <ServiceTable
              data={services_}
              columns={getCustomServiceColumns(handleOpenProductSelection, categoryHasProducts)}
            />
{isMobileLocation(props.currentLocation) ? (
  <MobileAppointmentForm
    currentStep={5}
    currentLocation={props.currentLocation}
    customerLat={request?.customer_address_lat ?? request?.latitude}
    customerLng={request?.customer_address_long ?? request?.longitude}
    services={services}
    appointmentStart={appointmentStart}
    onAppointmentChange={setAppointmentStart}
    excludeRequestId={request?.scheduledStart ? request.requestId : null}
  />
) : (
  <>
    <AvailabilityAlert
      availability={availability}
      calendarDays={calendarDays}
      requestId={request.requestId}
      selectedDate={sDate}
      jobType={request.requestType}
    />
    <DatePickerSection
      sDate={sDate}
      minDate={minDate}
      maxDate={maxDate}
      exclude={[]}
      existingCommitmentDates={existingCommitmentDates}
      onStartDateChange={onStartDateChange}
      label="Pick Start Date"
      closedDays={availability?.closedDays || []}
      blockedDates={availability?.blockedDates || []}
    />
  </>
)}
            <div className="jv-btn-group-spaced">
              <ActionButton
                onClick={() => onAccept(request, sDate, appointmentStart)}
                className="jv-btn jv-btn-primary"
                userAccess={userAccess}
                disabled={isMobileLocation(props.currentLocation) && !appointmentStart}
              >
                Claim
              </ActionButton>

              <span className="jv-btn-group-divider" />

              <ActionButton
                onClick={() => onReject(request)}
                className="jv-btn jv-btn-danger"
                userAccess={userAccess}
              >
                Reject
              </ActionButton>
            </div>
          </div>
        </div>

      </React.Fragment>
    );
  }

  // Installer receiving car from dealer/customer
  if (request.currentState === REQUEST_STATES.SCHEDULED && userType === USER_TYPES.INSTALLER) {
    const services_ = prepareServiceData(services);
    const hasTechnicians = locationTechnicians && locationTechnicians.length > 0;

    // Columns for check-in page - Service, Amount, Duration, and optionally Assigned To
    const getCheckinServiceColumns = () => [
      {
        dataField: "custom_description",
        text: "Service",
        formatter: (cell, row) => {
          // Check if service has items (new model)
          const hasItems = row.items && row.items.length > 0;
          const materialItems = hasItems ? row.items.filter(i => !i.type || i.type === 'material') : [];
          const allItemsAssigned = materialItems.length > 0 && materialItems.every(i => i.recommended_product_id);

          // Legacy: check if recommended product is set (service-level)
          const hasRecommendedProduct = !hasItems && row.recommended_product_id && row.recommended_product_name;
          const recommendedProductDisplay = hasRecommendedProduct
            ? (row.recommended_product_brand
                ? `${row.recommended_product_brand} - ${row.recommended_product_name}`
                : row.recommended_product_name)
            : null;

          const cat = row.service_category ? `${row.service_category} - ` : '';

          return (
            <div>
              <div className="d-flex align-items-start justify-content-between">
                <div className="flex-grow-1">
                  <span>{cat}{cell || row.description || '-'}</span>

                  {/* Show per-item product list — only items with a product assigned */}
                  {hasItems && materialItems.filter(i => i.recommended_product_id).map(item => (
                    <div key={item.id} className="small mt-1 text-success">
                      <i className="fa-sharp fa-regular fa-check mr-1"></i>
                      <strong>{item.label}:</strong> {item.recommended_product_brand
                        ? `${item.recommended_product_brand} - ${item.recommended_product_name}`
                        : item.recommended_product_name}
                    </div>
                  ))}

                  {/* Legacy fallback: show service-level recommended product */}
                  {hasRecommendedProduct && (
                    <div className="small text-success mt-1">
                      <i className="fa-sharp fa-regular fa-check mr-1"></i>
                      <strong>Use:</strong> {recommendedProductDisplay}
                    </div>
                  )}
                </div>

                {/* Cube button - always opens ServiceItemsModal */}
                {onSelectProduct && (
                  <button
                    type="button"
                    className={`btn btn-sm ml-2 ${allItemsAssigned ? 'btn-outline-success' : 'btn-outline-secondary'}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenProductSelection(row);
                    }}
                    title={allItemsAssigned ? 'All items assigned' : 'Manage service items'}
                    style={{ padding: '2px 6px', flexShrink: 0 }}
                  >
                    <i className={`fa-sharp fa-regular ${allItemsAssigned ? 'fa-check' : 'fa-cube'}`}></i>
                  </button>
                )}
              </div>
            </div>
          );
        }
      },
      {
        dataField: "service_amount",
        text: "Amount",
        formatter: (cell, row) => formatServiceAmount(row)
      },
      { dataField: "service_duration", text: "Duration" },
      // Technician assignment column - only show if technicians exist
      ...(hasTechnicians ? [{
        dataField: "assigned_technician_id",
        text: "Lead tech",
        formatter: (cell, row) => {
          const ta = row.tech_assignment;
          const totalTaskCount = ta?.total_task_count ?? 0;
          const splitEligible = totalTaskCount >= 2 && locationTechnicians.length >= 2;
          const isMixed = ta?.effective_state === 'mixed';
          const isPartial = ta?.effective_state === 'partial';
          const displayValue = isMixed || isPartial ? null : cell;
          const displayPlaceholder = isMixed
            ? 'Multiple techs'
            : isPartial
            ? 'Partially assigned'
            : 'Unassigned';
          const openSplit = (e) => {
            if (e) e.stopPropagation();
            if (onSplitAssignment) onSplitAssignment(row);
          };
          return (
            <div>
              <div className="d-flex align-items-center">
                <TechPicker
                  technicians={locationTechnicians}
                  value={displayValue}
                  placeholder={displayPlaceholder}
                  onChange={(techId) => onAssignTechnician(request.requestId, row.service_id, techId, row.id)}
                  onSplit={splitEligible ? () => openSplit() : undefined}
                />
                {/* Instructions icon - only show if assigned */}
                {cell && (
                  <button
                    type="button"
                    className="btn btn-sm btn-link p-0 ml-2"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditInstructions(row);
                    }}
                    title={row.technician_instructions ? "Edit instructions" : "Add instructions"}
                  >
                    <i className={`fa-sharp fa-regular fa-sticky-note ${row.technician_instructions ? 'text-info' : 'text-muted'}`}></i>
                  </button>
                )}
              </div>
            </div>
          );
        }
      }] : [])
    ];

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            {/* Services table with assignment - above scheduled date */}
            <ServiceTable
              data={services_}
              columns={getCheckinServiceColumns()}
            />
          </div>

          {/* ADD DEPOSIT MESSAGE HERE - BEFORE VehicleInfo */}
          {request.depositAmount > 0 && request.requestType === 'installer' && (
            <div className={`alert ${request.depositIsPaid ? 'alert-success' : 'alert-warning'} mx-3 mb-3`}>
              <strong>Deposit Required:</strong> ${parseFloat(request.depositAmount || 0).toFixed(2)}
              <div>
                <span className={request.depositIsPaid ? 'text-success' : 'text-warning'}>
                  {request.depositIsPaid
                    ? <><i className="fa-sharp fa-regular fa-check mr-1"></i> Paid</>
                    : <><i className="fa-sharp fa-regular fa-clock mr-1"></i> Not Paid</>
                  }
                </span>
                {request.depositPaidAmount > 0 && (
                  <small className="d-block">${parseFloat(request.depositPaidAmount || 0).toFixed(2)} received</small>
                )}
              </div>
            </div>
          )}

          <VehicleInfo
            request={request}
            scheduledDate={scheduledStartDate}
          />
          <div className="jv-btn-group-spaced">
            <ActionButton
              onClick={() => handleCheckIn(request, routerHistory)}
              className="jv-btn jv-btn-primary"
              userAccess={userAccess}
            >
              Check In
            </ActionButton>

            <span className="jv-btn-group-divider" />

            {request.requestType === 'installer' && (
              <ActionButton
                onClick={() => onShowDepositModal(request)}
                className="jv-btn jv-btn-tertiary"
                userAccess={userAccess}
              >
                Set Deposit
              </ActionButton>
            )}

            <ActionButton
              onClick={() => onReschedule(request)}
              className="jv-btn jv-btn-secondary"
              userAccess={userAccess}
            >
              Reschedule
            </ActionButton>
            <ActionButton
              onClick={() => onEdit(request)}
              className="jv-btn jv-btn-secondary"
              userAccess={userAccess}
            >
              Edit
            </ActionButton>

            <span className="jv-btn-group-divider" />

            <ActionButton
              onClick={() => onDelete(request)}
              className="jv-btn jv-btn-danger"
              userAccess={userAccess}
            >
              Delete
            </ActionButton>
          </div>

          {/* Deposit Modal */}
          <DepositModal
            show={showDepositModal}
            onHide={onHideDepositModal}
            request={request}
            onSaveDeposit={onSaveDeposit}
          />
        </div>

        {/* Technician Instructions Modal - for SCHEDULED state */}
        <TechnicianInstructionsModal
          show={showInstructionsModal}
          onHide={() => {
            setShowInstructionsModal(false);
            setEditingService(null);
          }}
          service={editingService}
          onSave={handleSaveInstructions}
          saving={savingInstructions}
        />

        {/* Materials View Modal - for SCHEDULED state */}
        <Modal
          show={showMaterialsViewModal}
          onHide={() => {
            setShowMaterialsViewModal(false);
            setMaterialsViewService(null);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fa-sharp fa-regular fa-cubes mr-2"></i>
              Materials Used
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {materialsViewService && (
              <div>
                <div className="mb-3">
                  <strong>{materialsViewService.service_category}</strong>
                  {materialsViewService.custom_description && (
                    <span className="text-muted"> - {materialsViewService.custom_description}</span>
                  )}
                </div>

                {materialsViewService.materials && materialsViewService.materials.length > 0 ? (
                  <div className="materials-list">
                    {materialsViewService.materials.map((material, index) => (
                      <div key={index} className="p-2 mb-2 border rounded">
                        <div className="font-weight-bold">
                          {material.brand && <span>{material.brand} - </span>}
                          {material.product_name}
                        </div>
                        {material.quantity_used && (
                          <div className="text-muted small">
                            Quantity: {material.quantity_used} {material.unit_code || ''}
                          </div>
                        )}
                        {material.barcode && (
                          <div className="text-muted small">
                            Roll: <code>{material.barcode}</code>
                          </div>
                        )}
                        {material.lot_number && (
                          <div className="text-muted small">
                            Lot: <code>{material.lot_number}</code>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No materials tracked.</p>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setShowMaterialsViewModal(false);
              setMaterialsViewService(null);
            }}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }

  // Service work states for Installer
  const installerWorkStates = [REQUEST_STATES.RECEIVED, REQUEST_STATES.STARTED];
  if (installerWorkStates.includes(request.currentState) && userType === USER_TYPES.INSTALLER) {
    const selectRow = {
      mode: "radio",
      clickToSelect: true,
      style: { bgColor: "grey" },
      onSelect: (e, row, rowIndex) => {
        onSelectService(rowIndex);
      },
    };

    const services_ = prepareServiceData(services);

    // Determine which columns to use based on whether technicians exist at this location
    const hasTechnicians = locationTechnicians && locationTechnicians.length > 0;
    const workColumns = hasTechnicians
      ? getWorkServiceColumns(locationTechnicians, onAssignTechnician, handleEditInstructions, request.requestId, handleShowMaterials, handleOpenProductSelection, categoryHasProducts, onSplitAssignment)
      : getBasicWorkServiceColumns(handleShowMaterials);

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <div className="row text-center">
              <div className="col text-center">
                <h5 className="card-title">
                  VIN :{" "}
                  <span
                    onClick={() => copyToClipboard(request.vin, 'vin')}
                    style={{ cursor: 'pointer', borderBottom: '1px dashed #6c757d', position: 'relative' }}
                    title="Click to copy VIN"
                  >
                    {copiedField === 'vin' && (
                      <span style={{ position: 'absolute', top: '-1.5em', left: '50%', transform: 'translateX(-50%)', fontSize: '0.7rem', whiteSpace: 'nowrap', color: '#28a745' }}>
                        Copied to Clipboard
                      </span>
                    )}
                    {request.vin}
                    <i className="fa-sharp fa-regular fa-copy text-muted ml-2" style={{ fontSize: '0.8rem' }}></i>
                  </span>
                </h5>
              </div>
            </div>
            {/* CarFax data missing warning — retail jobs only, when not opted out */}
            {request.requestType === 'installer' && !checkinCarfaxOptOut && (
              !checkinOdometerReading || !checkinPlate
            ) && (
              <div className="alert alert-warning text-left mx-3 mt-2 mb-0 d-flex justify-content-between align-items-center" style={{ fontSize: '0.9rem' }}>
                <div>
                  <i className="fa-sharp fa-regular fa-exclamation-triangle mr-2"></i>
                  <strong>CarFax data needed before completion:</strong>{' '}
                  {[
                    !checkinOdometerReading && 'Odometer reading',
                    !checkinPlate && 'Plate state'
                  ].filter(Boolean).join(', ')}
                </div>
                {onCarfaxOptOut && (
                  <button
                    className="btn btn-sm btn-outline-secondary ml-3"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={() => {
                      if (window.confirm('Disable CarFax reporting for this job?')) {
                        onCarfaxOptOut(request.requestId);
                      }
                    }}
                  >
                    <i className="fa-sharp fa-regular fa-times mr-1"></i>
                    Disable CarFax
                  </button>
                )}
              </div>
            )}

            <div className="mt-4 mb-4">
              <ServiceTable
                data={services_}
                columns={workColumns}
                selectRow={selectRow}
              />
              <form>
                <div className="bg-light rounded p-3 mb-3 shadow-sm">
                  <div className="jv-btn-group-spaced">
                    <ActionButton
                      onClick={() => onStart(request, thisJob, services_[selectedService])}
                      className="jv-btn jv-btn-primary"
                      disabled={!rowSelected || (rowSelected && services_[selectedService].service_state !== SERVICE_STATES.NEW)}
                      userAccess={userAccess}
                    >
                      Start
                    </ActionButton>
                    <ActionButton
                      onClick={() => onFinish(request, thisJob, services_[selectedService])}
                      className="jv-btn jv-btn-primary"
                      disabled={!rowSelected || (rowSelected && services_[selectedService].service_state !== SERVICE_STATES.STARTED)}
                      userAccess={userAccess}
                    >
                      Finish
                    </ActionButton>
                  </div>
                </div>
                <div className="jv-btn-group-spaced">
                  <ActionButton
                    onClick={() => onEdit(request)}
                    className="jv-btn jv-btn-secondary"
                    userAccess={userAccess}
                  >
                    Edit
                  </ActionButton>
                  {noteText !== "None" && (
                    <button
                      type="button"
                      onClick={() => alert(noteText)}
                      className="jv-btn jv-btn-tertiary"
                    >
                      Notes
                    </button>
                  )}

                  <div className="jv-btn-group-divider">{'\u00A0'}</div>

                  <ActionButton
                    onClick={() => onComplete(request, services_)}
                    className="jv-btn jv-btn-primary"
                    userAccess={userAccess}
                  >
                    Complete
                  </ActionButton>

                  <div className="jv-btn-group-divider">{'\u00A0'}</div>
                  <ActionButton
                    onClick={() => onDelete(request)}
                    className="jv-btn jv-btn-danger"
                    userAccess={userAccess}
                  >
                    Delete
                  </ActionButton>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Technician Instructions Modal */}
        <TechnicianInstructionsModal
          show={showInstructionsModal}
          onHide={() => {
            setShowInstructionsModal(false);
            setEditingService(null);
          }}
          service={editingService}
          onSave={handleSaveInstructions}
          saving={savingInstructions}
        />

        {/* Materials View Modal */}
        <Modal
          show={showMaterialsViewModal}
          onHide={() => {
            setShowMaterialsViewModal(false);
            setMaterialsViewService(null);
          }}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fa-sharp fa-regular fa-cubes mr-2"></i>
              Materials Used
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {materialsViewService && (
              <div>
                <div className="mb-3">
                  <strong>{materialsViewService.service_category}</strong>
                  {materialsViewService.custom_description && (
                    <span className="text-muted"> - {materialsViewService.custom_description}</span>
                  )}
                </div>

                {materialsViewService.materials && materialsViewService.materials.length > 0 ? (
                  <div className="materials-list">
                    {materialsViewService.materials.map((material, index) => (
                      <div key={index} className="p-2 mb-2 border rounded">
                        <div className="font-weight-bold">
                          {material.brand && <span>{material.brand} - </span>}
                          {material.product_name}
                        </div>
                        {material.quantity_used && (
                          <div className="text-muted small">
                            Quantity: {material.quantity_used} {material.unit_code || ''}
                          </div>
                        )}
                        {material.barcode && (
                          <div className="text-muted small">
                            Roll: <code>{material.barcode}</code>
                          </div>
                        )}
                        {material.lot_number && (
                          <div className="text-muted small">
                            Lot: <code>{material.lot_number}</code>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No materials tracked.</p>
                )}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {
              setShowMaterialsViewModal(false);
              setMaterialsViewService(null);
            }}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }

  // Customer/Dealer picks up car from Installer
  if (request.currentState === REQUEST_STATES.FINISHED && userType === USER_TYPES.INSTALLER) {
    // UNIFIED PICKUP SCREEN for installer jobs


    let PO = "Not Yet";
    if ((Object.keys(workingInvoice?.metadata || {})).length > 3 && workingInvoice?.metadata?.PO > "") {
      PO = Object.values(workingInvoice.metadata.PO);
    } else if (request.poNumber || request.po_number) {
      PO = request.poNumber || request.po_number;
    }

    // Compute amounts — always derive from request data for consistency.
    // Amount Remaining uses Stripe invoice when available (tracks partial/split payments).
    const hasStripeInvoice = invoice && invoice.id;
    const isPaid = hasStripeInvoice && invoice.paid;
    const customerTotal = (request.requestTotal || 0) - (request.requestDiscount || 0) + (request.requestTaxes || 0);
    const depositCredit = parseFloat(request.depositAmount) || 0;
    const amountOwed = customerTotal.toFixed(2);
    const amountRemaining = hasStripeInvoice
      ? (!invoice.paid ? (invoice.amount_remaining / 100).toFixed(2) : '0.00')
      : (customerTotal - depositCredit).toFixed(2);
    const hasPaymentsCollected = collectedPayments.length > 0 || (depositCredit > 0 && request.depositIsPaid);

    // Resend handler adapts to invoice state
    const handleResend = hasStripeInvoice
      ? () => onResend(invoice.id)
      : onResendDraftEmail;

    return (
      <React.Fragment>
        <div className="card text-center">
          <div className="card-body">
            <div className="mb-2">
              VIN : {request.vin.substring(0,2) === "NV" ? (<b>Not Collected</b>) : (
                <span
                  onClick={() => copyToClipboard(request.vin, 'vin-finished')}
                  style={{ cursor: 'pointer', borderBottom: '1px dashed #6c757d', position: 'relative' }}
                  title="Click to copy VIN"
                >
                  {copiedField === 'vin-finished' && (
                    <span style={{ position: 'absolute', top: '-1.5em', left: '50%', transform: 'translateX(-50%)', fontSize: '0.7rem', whiteSpace: 'nowrap', color: '#28a745' }}>
                      Copied to Clipboard
                    </span>
                  )}
                  {request.vin}
                  <i className="fa-sharp fa-regular fa-copy text-muted ml-2" style={{ fontSize: '0.8rem' }}></i>
                </span>
              )}
            </div>
            <div className="mb-2">
              Amount Owed : ${amountOwed}
            </div>
            {depositCredit > 0 && (
              <div className="mb-2 text-success">
                Deposit Credit : -${depositCredit.toFixed(2)}
              </div>
            )}
            {request.requestType === REQUEST_TYPES.DEALER && !isPaid && (
              <div className="mb-2">
                PO Received : {PO}
              </div>
            )}
            <div className="mb-3">
              Amount Remaining : ${amountRemaining}
            </div>

        {/* Upload completion photos */}
        <div className="jv-btn-group-spaced">
          <ActionButton
            onClick={() => setShowCompletionPhotos(true)}
            className="jv-btn jv-btn-tertiary"
            userAccess={userAccess}
          >
            {isMobile ? 'Take Completion Photos' : 'Upload Completion Photos'}
          </ActionButton>
        </div>

        {/* PAID installer job */}
        {(isPaid && request.requestType === REQUEST_TYPES.INSTALLER) && (
          <div className="jv-btn-group-spaced">
            <ActionButton
              onClick={handleResend}
              className="jv-btn jv-btn-primary"
              userAccess={userAccess}
            >
              Send Invoice
            </ActionButton>

            <span className="jv-btn-group-divider" />

            <ActionButton
              onClick={() => onDeliver(request)}
              className="jv-btn jv-btn-secondary"
              userAccess={userAccess}
            >
              Deliver
            </ActionButton>
          </div>
        )}

        {/* UNPAID installer job — unified for draft, Stripe draft, and Stripe open */}
        {(!isPaid && request.requestType === REQUEST_TYPES.INSTALLER) && (
          <div>
            <div className="row text-center">
              <div className="col-4"/>
              <div className="col-4 text-center">
                <Select
                  name="paymethod"
                  label=" "
                  options={payList}
                  value={selectedPay}
                  onChange={onPaymentChange}
                />
              </div>
            </div>

            {selectedPay === "Check" && (
              <div className="row text-center mt-3">
                <div className="col-4"/>
                <div className="col-4">
                  <div className="form-group">
                    <label htmlFor="checkNumber" className="font-weight-bold">
                      Check Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="checkNumber"
                      name="checkNumber"
                      className="form-control"
                      value={checkNumber}
                      onChange={onCheckNumberChange}
                      placeholder="Enter check number"
                      required
                      autoFocus
                    />
                    <small className="form-text text-muted">
                      Required for check payments
                    </small>
                  </div>
                </div>
              </div>
            )}

            <div className="jv-btn-group-spaced mt-3">
              <ActionButton
                onClick={() => {
                  if (selectedPay === "Split Payment") {
                    setShowSplitPaymentModal(true);
                  } else {
                    onPayment();
                  }
                }}
                className="jv-btn jv-btn-primary"
                userAccess={userAccess}
                disabled={isMaterializing || !selectedPay}
              >
                {isMaterializing ? 'Processing...' : 'Process Payment'}
              </ActionButton>

              <span className="jv-btn-group-divider" />

              <ActionButton
                onClick={handleResend}
                className="jv-btn jv-btn-secondary"
                userAccess={userAccess}
              >
                Resend Invoice
              </ActionButton>

              {!hasPaymentsCollected && (
                <>
                  <span className="jv-btn-group-divider" />

                  <ActionButton
                    onClick={() => onVoidInvoice(request)}
                    className="jv-btn jv-btn-secondary"
                    userAccess={userAccess}
                  >
                    Edit
                  </ActionButton>
                </>
              )}

              <span className="jv-btn-group-divider" />

              <ActionButton
                onClick={() => onDelete(request)}
                className="jv-btn jv-btn-danger"
                userAccess={userAccess}
              >
                Delete
              </ActionButton>
            </div>
          </div>
        )}

        {(request.requestType === REQUEST_TYPES.DEALER) && (
          <div>
            {/* Dealer: pre-real-invoice — draft exists, show payment dropdown + Process Payment + Deliver + Edit/Delete + Add PO */}
            {!hasStripeInvoice && (
              <div>
                <div className="row text-center">
                  <div className="col-4"/>
                  <div className="col-4 text-center">
                    <Select
                      name="paymethod"
                      label=" "
                      options={payList}
                      value={selectedPay}
                      onChange={onPaymentChange}
                    />
                  </div>
                </div>

                <div className="jv-btn-group-spaced mt-3">
                  <ActionButton
                    onClick={onPayment}
                    className="jv-btn jv-btn-primary"
                    userAccess={userAccess}
                    disabled={isMaterializing || !selectedPay}
                  >
                    {isMaterializing ? 'Processing...' : 'Process Payment'}
                  </ActionButton>

                  <ActionButton
                    onClick={() => onDeliver(request)}
                    className="jv-btn jv-btn-primary"
                    userAccess={userAccess}
                    disabled={isMaterializing}
                  >
                    Deliver
                  </ActionButton>

                  <span className="jv-btn-group-divider" />

                  {PO === "Not Yet" && (
                    <ActionButton
                      onClick={() => onAddPO()}
                      className="jv-btn jv-btn-tertiary"
                      userAccess={userAccess}
                    >
                      Add PO
                    </ActionButton>
                  )}

                  <ActionButton
                    onClick={() => onEdit(request)}
                    className="jv-btn jv-btn-secondary"
                    userAccess={userAccess}
                  >
                    Edit
                  </ActionButton>

                  <span className="jv-btn-group-divider" />

                  <ActionButton
                    onClick={() => onDelete(request)}
                    className="jv-btn jv-btn-danger"
                    userAccess={userAccess}
                  >
                    Delete
                  </ActionButton>
                </div>
              </div>
            )}

            {/* Dealer: Post-deliver — invoice exists */}
            {hasStripeInvoice && (
              <>
                {/* Payment options for open invoices */}
                {invoice.status === "open" && (
                  <div>
                    <div className="row text-center">
                      <div className="col-4"/>
                      <div className="col-4 text-center">
                        <Select
                          name="paymethod"
                          label=" "
                          options={payList}
                          value={selectedPay}
                          onChange={onPaymentChange}
                        />
                      </div>
                    </div>

                    {selectedPay === "Check" && (
                      <div className="row text-center mt-3">
                        <div className="col-4"/>
                        <div className="col-4">
                          <div className="form-group">
                            <label htmlFor="checkNumber" className="font-weight-bold">
                              Check Number <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              id="checkNumber"
                              name="checkNumber"
                              className="form-control"
                              value={checkNumber}
                              onChange={onCheckNumberChange}
                              placeholder="Enter check number"
                              required
                              autoFocus
                            />
                            <small className="form-text text-muted">
                              Required for check payments
                            </small>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="jv-btn-group-spaced">
                      <ActionButton
                        onClick={() => onResend(invoice.id)}
                        className="jv-btn jv-btn-primary"
                        userAccess={userAccess}
                      >
                        Send Invoice
                      </ActionButton>
                      <ActionButton
                        onClick={() => {
                          if (selectedPay === "Split Payment") {
                            setShowSplitPaymentModal(true);
                          } else {
                            onPayment();
                          }
                        }}
                        className="jv-btn jv-btn-primary"
                        userAccess={userAccess}
                      >
                        Process Payment
                      </ActionButton>
                    </div>
                  </div>
                )}

                <div className="jv-btn-group-spaced">
                  {request.currentState !== 'collected' && (
                    <ActionButton
                      onClick={() => onDeliver(request)}
                      className="jv-btn jv-btn-primary"
                      userAccess={userAccess}
                    >
                      Deliver
                    </ActionButton>
                  )}
                  {invoice.status !== "open" && (
                    <ActionButton
                      onClick={() => onResend(invoice.id)}
                      className="jv-btn jv-btn-primary"
                      userAccess={userAccess}
                    >
                      Send Invoice
                    </ActionButton>
                  )}
                  {PO === "Not Yet" && (
                    <ActionButton
                      onClick={() => onAddPO()}
                      className="jv-btn jv-btn-tertiary"
                      userAccess={userAccess}
                    >
                      Add PO
                    </ActionButton>
                  )}

                  <span className="jv-btn-group-divider" />

                  {/* Edit and Delete — only when invoice is not paid */}
                  {!invoice.paid && (
                    <>
                      <ActionButton
                        onClick={() => onVoidInvoice(request)}
                        className="jv-btn jv-btn-secondary"
                        userAccess={userAccess}
                      >
                        Edit
                      </ActionButton>

                      <span className="jv-btn-group-divider" />

                      <ActionButton
                        onClick={() => onDelete(request)}
                        className="jv-btn jv-btn-danger"
                        userAccess={userAccess}
                      >
                        Delete
                      </ActionButton>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        )}

        {/* Split Payment Modal */}
        <SplitPaymentModal
          show={showSplitPaymentModal}
          onHide={() => setShowSplitPaymentModal(false)}
          request={request}
          invoice={invoice}
          collectedPayments={collectedPayments}
          remainingBalance={remainingBalance}
          splitPaymentAmount={splitPaymentAmount}
          selectedSplitMethod={selectedSplitMethod}
          splitCheckNumber={splitCheckNumber}
          isProcessingSplitPayment={isProcessingSplitPayment}
          splitPaymentError={splitPaymentError}
          onSplitMethodChange={onSplitMethodChange}
          onSplitAmountChange={onSplitAmountChange}
          onSplitCheckNumberChange={onSplitCheckNumberChange}
          onCollectSplitPayment={onCollectSplitPayment}
          userAccess={userAccess}
        />

        {/* Online Invoice Link Modal */}
        {showInvoiceLinkModal && (
          <Modal show={showInvoiceLinkModal} onHide={onCloseInvoiceLinkModal} centered>
            <Modal.Header closeButton>
              <Modal.Title>Online Payment Invoice Created</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>The invoice has been created and sent to the customer's email.</p>
              <p>You can also share this payment link:</p>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  value={currentInvoiceLink}
                  readOnly
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      navigator.clipboard.writeText(currentInvoiceLink);
                      alert('Link copied to clipboard!');
                    }}
                  >
                    Copy
                  </button>
                </div>
              </div>
              <p className="mt-3 text-muted">
                <small>Close this modal to refresh and see the payment status.</small>
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={onCloseInvoiceLinkModal}>
                Close & Refresh
              </Button>
            </Modal.Footer>
          </Modal>
        )}

          </div>
        </div>

        {selectedPay === "SWIPE CARD" && showSwipe && (
        <PaymentProgressModal
          show={showSwipe}
          onClose={closeSwipe}
          paymentState={paymentState}
          paymentError={paymentError}
          invoice={invoice}
          installer={installer}
          onRetry={onRetryPayment}
          onCancel={onCancelTerminal}
        />
      )}

        {showPO && (
          <AddPO
            show={showPO}
            onClose={closePO}
            type={"dealer"}
            requestId={request.requestId}
            invoiceId={hasStripeInvoice ? invoice.id : null}
            poNumber={PO}
            onPO={onPO}
            onInvoice={onSettle}
          />
        )}

        {showCompletionPhotos && (
          <CompletionPhotosModal
            show={showCompletionPhotos}
            onHide={() => setShowCompletionPhotos(false)}
            requestId={request.requestId}
            onSuccess={handleCompletionPhotosSuccess}
          />
        )}
      </React.Fragment>
    );
  }

  return null;
};

export default RequestimateState;